import { useTranslation } from 'react-i18next';
import ChatStyles from './Chat.module.css';

const EncryptionBanner = ({ encryptedSecurityKey, selectedUser }) => {
  const { t } = useTranslation();
  return (
    <div className={ChatStyles.encBanner}>
      <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
        <rect x='3' y='11' width='18' height='11' rx='2' />
        <path d='M7 11V7a5 5 0 0 1 10 0v4' />
      </svg>
      {t('screens.chat.encBannerMain')}<strong>&nbsp;{t('screens.chat.encBannerBold')}&nbsp;</strong>{t('screens.chat.encBannerAes')}
      <span>&nbsp;{t('screens.chat.encBannerOnlyYou', { name: selectedUser.name })}</span>
      {encryptedSecurityKey.data?.key && <span className={ChatStyles.encKeyId}>{t('screens.chat.encBannerKey', { key: encryptedSecurityKey.data.key.slice(0, 8) })}</span>}
    </div>
  );
};

export default EncryptionBanner;
